export const FETCH_CURRENT_PAGE = "fetchCurrentPageData";
export const FETCH_CAMPAIGN_DATA = "fetchCampaignData";
export const FETCH_BRAND_DATA = "fetchBrandData";
export const FETCH_JOB_DATA = "fetchJobData";
export const FETCH_JOBLIST_DATA = "fetchJoblistData";
export const FETCH_CONTACT_DATA = "fetchContactData";
export const FETCH_INVEST_DATA = "fetchInvestData";
export const FETCH_WORK_DATA = "fetchWorkData";
export const FETCH_NEWS_DATA = "fetchNewsData";
export const FETCH_PRODUCT_DATA = "fetchProductData";
export const FETCH_BLOG_POSTS = "fetchBlogPosts";
export const FETCH_PAGE_BY_ID = "fetchPageByID";
export const FETCH_CHILDREN = "fetchChildren";
export const FETCH_MAIN_MENU = "fetchMainMenu";
export const SERCH_STORE = "searchStore";
export const FETCH_RMAIN_MENU = "fetchRmainMenu";
export const FETCH_SOCIAL = "fetchSocialData";
export const FETCH_GLOBAL = "fetchGlobalData";
export const FETCH_QUARTERLY_REPORTS = "fetchQuarterlyReports";
export const FETCH_ANNUAL_REPORTS = "fetchAnnualReports";
export const FETCH_SENSITIVE_REPORTS = "fetchSensitiveReports";
export const FETCH_SETTING_DATA = "fetchSettingData";
